module.exports = new Promise((resolve, reject) => {
    const timestamp = Date.now();

    const loadScript = (baseUrl, scriptId) => new Promise((res, rej) => {
      if (document.getElementById(scriptId)) {
        return res();
      }
      const s = document.createElement('script');
      s.src = baseUrl + '?v=' + timestamp;
      s.id = scriptId;
      s.onload = () => {
        res();
      };
      s.onerror = (err) => {
        rej(err);
      };
      document.head.appendChild(s);
    });

    const baseUrl = 'https://mi-cuenta-2.ripley.cl';
    loadScript(baseUrl + '/_next/static/chunks/webpack.js', 'remote-webpack-js')
      .catch((err) => {
        return Promise.resolve();
      })
      .then(() => {
        return loadScript(baseUrl + '/_next/static/chunks/remoteEntry.js', 'remote-entry-js');
      })
      .then(() => {
        let retries = 50;
        const check = () => {
          if (window.mi_cuenta_2) {
            resolve(window.mi_cuenta_2);
          } else if (retries > 0) {
            retries--;
            setTimeout(check, 50);
          } else {
            reject(new Error('Timeout al cargar el microfrontend mi_cuenta_2.'));
          }
        };
        check();
      })
      .catch((err) => {
        reject(err);
      });
  });